export default __webpack_public_path__ + "static/media/phonebg4.f542edb1.svg";